<template>
    <div>
        <div class="content-header">
            <h3>查询</h3>
            <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item>
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    <el-button type="primary" @click="getList">查询</el-button>
                    <el-button type="success" @click="handleAdd">新增</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-wrap">
            <el-table :data="dataList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="regularName" label="名称"></el-table-column>
                <el-table-column prop="regularTypeName" label="类型"></el-table-column>
                <el-table-column prop="regularPrice" label="总价"></el-table-column>
                <el-table-column prop="regularOriginPrice" label="原价"></el-table-column>
                <el-table-column prop="regularCount" label="数量"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
                <el-table-column :formatter="convertStatus" label="状态"></el-table-column>
                <el-table-column prop="platformGroupName" label="公司"></el-table-column>
                <el-table-column prop="regularDeliverCount" label="配送次数"></el-table-column>
                <el-table-column :formatter="convertMode" prop="priceMode" label="计价方式"></el-table-column>
                <el-table-column prop="discount" label="折扣"></el-table-column>
                <el-table-column label="操作" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-button type="warning " size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="长期订购管理" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="名称" :required="true">
                    <el-input v-model="form.regularName" placeholder="名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select :popper-append-to-body="true" v-model="form.regularType">
                        <el-option
                                v-for="item in getRegularTypeList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="总价" :required="true">
                    <el-input-number v-model="form.regularPrice" clearable></el-input-number>
                </el-form-item>
                <el-form-item label="原价" :required="true">
                    <el-input-number v-model="form.regularOriginPrice" clearable></el-input-number>
                </el-form-item>
                <el-form-item label="数量" :required="true">
                    <el-input-number v-model="form.regularCount" clearable></el-input-number>
                </el-form-item>
                <el-form-item label="配送次数" :required="true">
                    <el-input-number v-model="form.regularDeliverCount" clearable></el-input-number>
                </el-form-item>
                <el-form-item label="折扣" :required="true">
                    <el-input-number v-model="form.discount" :min="0.0" :max="1" :step="0.01" clearable></el-input-number>
                </el-form-item>
                <el-form-item label="折扣方式">
                    <el-select :popper-append-to-body="true" v-model="form.priceMode">
                        <el-option
                                v-for="item in priceModeList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select :popper-append-to-body="true" v-model="form.status">
                        <el-option
                                v-for="item in statusList"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {
        getRegularTypeList,
        getRegularList,
        saveOrUpdateRegular,
    } from '../../api/api';


    //定义组件
    export default {
        data() {
            return {
                dataList: [],
                getRegularTypeList: [],
                statusList: [{value: 1, name: '有效'}, {value: 0, name: '无效'}],
                priceModeList: [{value: 1, name: '金额'}, {value: 2, name: '折扣'}],
                loading: true,
                dialogFormVisible: false,
                formInline: {
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                form: {
                    regularId: '',
                    regularName: '',
                    regularType: '',
                    regularPrice: '',
                    regularOriginPrice: '',
                    regularCount: '',
                    status: 1,
                    regularDeliverCount: '',
                    priceMode: '',
                    discount: '',
                },
            }
        },
        //挂载时候执行
        mounted() {
            this.getList();
            getRegularTypeList().then((res) => {
                this.getRegularTypeList = res.data.value;
            })
        },
        methods: {
            //定义查询方法
            getList() {
                this.loading = true;
                getRegularList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.formInline.recordsTotal = res.data.value.total;
                        this.dataList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleAdd() {
                this.form.regularId = '';
                this.form.regularName =  '';
                this.form.regularType =  '';
                this.form.regularPrice = '' ;
                this.form.regularOriginPrice =  '';
                this.form.regularCount =  '';
                this.form.status =  1;
                this.form.regularDeliverCount =  '';
                this.form.priceMode = 2;
                this.form.discount =  '';
                this.dialogFormVisible = true;
            },
            handleUpdate(row) {
                this.form.regularId = row.regularId;
                this.form.regularName = row.regularName;
                this.form.regularType = row.regularType;
                this.form.regularPrice = row.regularPrice;
                this.form.regularOriginPrice = row.regularOriginPrice;
                this.form.regularCount = row.regularCount;
                this.form.status = row.status;
                this.form.regularDeliverCount = row.regularDeliverCount;
                this.form.priceMode = row.priceMode;
                this.form.discount = row.discount;
                this.dialogFormVisible = true;
            },
            updateOrAdd() {
                const loading = this.$loading(this.GCONFIG.loadingParam);
                saveOrUpdateRegular(this.form).then((res) => {
                    loading.close();
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            convertStatus(row, column, cellValue) {
                if (row.status == 1) {
                    return "有效";
                } else {
                    return "无效";
                }
            },
            convertMode(row, column, cellValue) {
                if (row.priceMode == 1) {
                    return "金额";
                } else {
                    return "折扣";
                }
            },
            returnHistory(){
                window.history.go(-1)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/sales/regular.vue